var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaySkipForwardicon = function SvgPlaySkipForwardicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.46 10.826-8.854-5.297a1.43 1.43 0 0 0-1.457-.018 1.58 1.58 0 0 0-.786 1.381v3.706l-8.471-5.07a1.43 1.43 0 0 0-1.458-.019A1.58 1.58 0 0 0 .65 6.891V17.25a1.58 1.58 0 0 0 .785 1.382 1.43 1.43 0 0 0 1.458-.018l8.47-5.073v3.707a1.58 1.58 0 0 0 .787 1.384 1.43 1.43 0 0 0 1.457-.018l8.853-5.297a1.465 1.465 0 0 0 0-2.485z"
  })));
};
export default SvgPlaySkipForwardicon;